module.exports = __webpack_public_path__ + "static/media/os.4ca6bd09.png";